/**
 * Access Centre list UI helpers (aligned with access-centre-api.md defaults).
 */

/** Default page size for users and roles list endpoints (GET /users, GET /roles). */
export const ACCESS_CENTRE_LIST_PAGE_SIZE = 10;

/** Rows-per-page options for users and roles tables (matches Contacts table). */
export const ACCESS_CENTRE_ROWS_PER_PAGE_OPTIONS = [5, 10, 20, 50, 100];
